import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { handleCloseModal } from 'redux/reducers/modal';
import { connect } from 'react-redux';
import './Modal.scss';

class Modal extends PureComponent {
    static propTypes = {
        handleCloseModal: PropTypes.func.isRequired,
        title: PropTypes.string,
        isCloseIfClickOutside: PropTypes.bool,
        isShowCloseIcon: PropTypes.bool,
        isOpen: PropTypes.bool,
        footer: PropTypes.element,
        body: PropTypes.element
    }

    static defaultProps = {
        isCloseIfClickOutside: true,
        isShowCloseIcon: true
    }

    onClickBackDrop = () => {
        if (this.props.isCloseIfClickOutside) {
            this.props.handleCloseModal();
        }
    }

    stopPropagation = (evt) => {
        evt.stopPropagation();
    }

    render() {
        const { title, isOpen, isShowCloseIcon, footer, body, handleCloseModal } = this.props;

        if (!isOpen) {
            return null;
        }

        return (
            <div className='Modal__backdrop' onClick={this.onClickBackDrop}>
                <div className='Modal__container' onClick={this.stopPropagation}>
                    <div className='Modal__header'>
                        <div className='Modal__title'>{title}</div>
                        { isShowCloseIcon && (
                            <div className='Modal__closeIconButton' onClick={handleCloseModal}>
                                <FontAwesomeIcon icon={faTimes} size='2x' className='Modal__closeIconButton_icon' />
                            </div>
                        )}
                    </div>
                    <div className='Modal__body'>{body}</div>
                    { footer && (
                        <div className='Modal__footer'>{footer}</div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isOpen: state.modal.isOpen,
    title: state.modal.title,
    isCloseIfClickOutside: state.modal.isCloseIfClickOutside,
    footer: state.modal.footer,
    body: state.modal.body
});

const mapDispatchToProps = {
    handleCloseModal
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
